import React from 'react';
import './styles.scss'

const Gallery = ({ gallery }) => {

    let galleryDisplay = gallery.length ? gallery.map((image,i) => (
        <div className="gallery-image" key={`gallery-image-${i}`}>
            <img src={image.image} alt={image.title} />
            <div className="image-description">
                <div className="year">{image.year}</div>
                <div className="title">{image.title}</div>
                <div className="description">{image.description}</div>
            </div>
        </div>
    )) : '';

    return (
        <section className='gallery-container'>
            { galleryDisplay && galleryDisplay }
        </section>
    );

}

export default Gallery;
